import React from "react";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import {withStyles} from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import {Table} from "@material-ui/core";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import PropTypes from "prop-types";

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
    fullWidth : {
        width: '100%',
        borderRadius: 0
    },
}));

class SwmsPartThree extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            swmsRelatesTo: props.state.swmsRelatesTo,
        };
        this.onChange = this.onChange.bind(this);
    }

    onChange(event) {
        this.props.onChangeHandler();
        this.setState({
            ...this.state, [event.target.name]: event.target.value
        });
    }

    render() {
        let {state} = this;

        return <Grid container spacing={0}>
            <Grid item xs={7}>
                <Paper square style={{ padding: "30px", height: "100%" }}>
                    <label htmlFor="title" style={{float: "left", textAlign: "right", clear: "both", marginRight: "15px"}}>This SWMS relates to</label>
                    <TextField
                        style={{width: "300px", marginTop: "-16px", marginBottom: "24px"}}
                        margin="normal"
                        id="swmsRelatesTo"
                        label=""
                        name="swmsRelatesTo"
                        value={state.swmsRelatesTo}
                        onChange={this.onChange}
                    />
                    <br/>
                    This SWMS does not cover hazardous manual tasks, hazardous chemicals, traffic management, working in confined spaces or working with electrical equipment in sufficient detail. Dedicated SWMS should be developed for these tasks, and for any risks not covered in this
                </Paper>
            </Grid>
            <Grid item xs={5}>
                <Paper square style={{ padding: "30px", height: "100%" }}>
                    <p><b>This work activity may involve the following "High Risk Construction Work":</b></p>
                    <p>
                        <ul style={{ listStyle: "square inside url('data:image/gif;base64,R0lGODlhBQAKAIABAAAAAP///yH5BAEAAAEALAAAAAAFAAoAAAIIjI+ZwKwPUQEAOw==')" }}>
                            <li>Moving Plant</li>
                            <li>Pressurised gas distribution mains or piping chemical, fuel or refrigerant lined energised electrical installations or services</li>
                            <li>Confined Spaces</li>
                            <li>Asbestos</li>
                            <li>Working at heights greater than 2 Metres, including work on telecommunications towers</li>
                            <li>Structures or buildings involving structural alterations or repairs that require temporary support to prevent collapse</li>
                        </ul>
                    </p>
                </Paper>
            </Grid>
            <Grid item xs={12} style={{ backgroundColor: 'lightblue', padding: "30px" }}>
                <Typography component="h6" variant="subtitle1">
                    Personal Protective Equipment (PPE)
                </Typography>
                <Typography component="h6" variant="subtitle2">
                    Ensure all PPE meets relevant Australian Standards. Inspect, and replace PPE as needed.
                </Typography>
            </Grid>
            <Grid item xs={12} style={{ padding: "30px" }}>
                <Typography component="p" variant="subtitle2">
                    AS 1319-1994 Safety signs for the occupational environment reproduced with permission from SAI Global under licence 1210-c062. Standards may be purchased at <a href="http://www.saiglobal.com" target="_blank">http://www.saiglobal.com</a>
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Table>
                    <TableHead>
                        <tr>
                            <th style={{ padding: "20px" }}>Foot Protection</th>
                            <th style={{ padding: "20px" }}>Hearing Protection</th>
                            <th style={{ padding: "20px" }}>High Visibility</th>
                            <th style={{ padding: "20px" }}>Head Protection</th>
                            <th style={{ padding: "20px" }}>Eye Protection</th>
                            <th style={{ padding: "20px" }}>Face Protection</th>
                            <th style={{ padding: "20px" }}>Hand Protection</th>
                            <th style={{ padding: "20px" }}>Protective Clothing</th>
                            <th style={{ padding: "20px" }}>Sun Protection</th>
                        </tr>
                    </TableHead>
                    <TableBody>
                        <tr>
                            <td style={{ padding: "20px" }}><img alt="Foot Protection" style={{ width: "64px" }} src="/images/swms/footProtection.png"/></td>
                            <td style={{ padding: "20px" }}><img alt="Hearing Protection" style={{ width: "64px" }} src="/images/swms/hearingProtection.png"/></td>
                            <td style={{ padding: "20px" }}><img alt="High Visability" style={{ width: "64px" }} src="/images/swms/highVisibility.png"/></td>
                            <td style={{ padding: "20px" }}><img alt="Head Protection" style={{ width: "64px" }} src="/images/swms/headProtection.png"/></td>
                            <td style={{ padding: "20px" }}><img alt="Eye Protection" style={{ width: "64px" }} src="/images/swms/eyeProtection.png"/></td>
                            <td style={{ padding: "20px" }}><img alt="Face Protection" style={{ width: "64px" }} src="/images/swms/faceProtection.png"/></td>
                            <td style={{ padding: "20px" }}><img alt="Hand Protection" style={{ width: "64px" }} src="/images/swms/handProtection.png"/></td>
                            <td style={{ padding: "20px" }}><img alt="Protective Clothing" style={{ width: "64px" }} src="/images/swms/protectiveClothing.png"/></td>
                            <td style={{ padding: "20px" }}>Broad brimmed hat, UV rated clothing, SPF 30+ sunscreen, tinted safety glasses with adequate UV protection)</td>
                        </tr>
                        <tr>
                            <td colSpan="9" style={{ padding: "20px" }}>
                                Rings, watches, jewellery that may become entangled in machines must not be worn. Long and loose hair must be tied back. Insulating gloves, insulating mats or sheeting, safety helmet, safety glasses, face protection and appropriate clothing (i.e. long sleeve cotton shirt and long pants) If glasses are worn ensure they are not metal as they may conduct electricity current
                            </td>
                        </tr>
                    </TableBody>
                </Table>
            </Grid>
        </Grid>;
    }
}

SwmsPartThree.propTypes = {
    onChangeHandler: PropTypes.func.isRequired,
};

export default withStyles(classes)(SwmsPartThree);